import { BadgeComponent, BarComponent, VatReturnAmountComponent } from "components/VatReturn";
import React, { Fragment, useEffect, useState } from "react";
import styles from "../../components/VatReturn/VatReturn.module.scss"
import CalenderImage from "../../assets/common/calender.png";
import { DateFormatFull } from "components/common/formatter";
import {
    calculationTempData,
    salesPurchasesExcludingVAT,
    ECSuppliesPurchasesExcludingVAT,
} from "./vatReturnBoxes";
import { Button } from "@progress/kendo-react-buttons";

const VatReturnTab = (props) => {
    const [calculationsData, setCalculationData] = useState(calculationTempData)
    const [salesExcludingVat, setSalesExcludingVat] = useState(salesPurchasesExcludingVAT)
    const [suppliesExcludingVat, setSuppliesExcludingVat] = useState(ECSuppliesPurchasesExcludingVAT)

    const updateVatInformation = () => {
        let item = props.data
        setTimeout(() => {
            setCalculationData(prevData => {
                return [{
                    ...prevData[0], amount: item.vatDueSales
                }, {
                    ...prevData[1], amount: item.vatDueAcquisitions
                }, {
                    ...prevData[2], amount: item.totalVatDue
                }, {
                    ...prevData[3], amount: item.vatReclaimedCurrPeriod
                }, {
                    ...prevData[4], amount: item.netVatDue
                }]
            })
            setSalesExcludingVat(prevData => {
                return [{
                    ...prevData[0], amount: item.totalValueSalesExVAT
                }, {
                    ...prevData[1], amount: item.totalValuePurchasesExVAT
                }]
            })
            setSuppliesExcludingVat(prevData => {
                return [{
                    ...prevData[0], amount: item.totalValueGoodsSuppliedExVAT
                }, {
                    ...prevData[1], amount: item.totalAcquisitionsExVAT
                }]
            })
        }, 100);
    }

    const updateData = (box, value) => {
        if (box >= 1 && box <= 5) {
            setCalculationData(prevData => {
                const data = prevData.map((item) => {
                    if (item.box === box) {
                        item.amount = value
                    }
                    return item;
                })
                return data
            })
        }
        else if (box === 6 || box === 7) {
            setSalesExcludingVat(prevData => {
                const data = prevData.map((item) => {
                    if (item.box === box) {
                        item.amount = value
                    }
                    return item;
                })
                return data
            })
        }
        else if (box === 8 || box === 9) {
            setSuppliesExcludingVat(prevData => {
                const data = prevData.map((item) => {
                    if (item.box === box) {
                        item.amount = value
                    }
                    return item;
                })
                return data
            })
        }
    }

    useEffect(() => {
        updateVatInformation()
    }, [props.data])

    return (
        <Fragment>

            <div className={`container-fluid ${styles['tab-container']}`}>
                <div className="row mt-2 align-items-center">
                    <div className="col d-flex align-items-center flex-wrap gap-2 my-2">
                        <p className="fs-md-3 me-2 mb-0 fw-bold cursor-default">Linq Legal Software Ltd</p>
                        <p className={`${styles['gray-text-color']} fs-md-3 fw-semibold mb-0 me-4 cursor-default`}>VAT Number 410905040</p>
                        {props.item?.toDate && (
                            <span className="d-flex align-items-center gap-1">
                                <img src={CalenderImage} width={14} height={14} alt="date" />
                                <p className={`${styles['gray-text-color']} fs-md-3 mb-0 fw-semibold cursor-default`}>{DateFormatFull(props.item.toDate)}</p>
                            </span>
                        )}
                    </div>

                </div>
                {props.hmrcMtd && (
                    <div className="row">
                        <div className="col-12 d-flex">
                            <BadgeComponent text='Due in 30 days' />
                            <p className={`${styles[`text-light-color`]} ms-3 me-3`}>|</p>
                            <p className={`${styles[`text-light-color`]} me-3`}>07 Sep 2023</p>
                            <p className={`${styles[`text-light-color`]} me-3`}>|</p>
                            <p className={`${styles[`text-light-color`]} me-3`}>Cash</p>
                            <p className={`${styles[`text-light-color`]} me-3`}>|</p>
                            <p className={`${styles[`text-light-color`]} me-3`}>Quarterly</p>
                            <p className={`${styles[`text-light-color`]} me-3`}>|</p>
                            <BadgeComponent text='Late claims included' />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-12">
                        <BarComponent />
                    </div>
                </div>
                <div className="row mt-3">
                    <p className="fs-md me-3">VAT Calculations</p>
                </div>
                <div className="flex-grow-1 overflow-auto overflow-x-hidden h-100 pe-3 mb-2">
                    {calculationsData?.map((item, index) => {
                        return <VatReturnAmountComponent
                            key={index}
                            box={item.box}
                            updateData={(box, value) => { updateData(box, value) }}
                            details={item.details}
                            amount={item.amount}
                        />
                    })}
                    <div className="row mt-1">
                        <p className="fs-md me-3">Sales and Purchases Excluding VAT</p>
                    </div>
                    {salesExcludingVat?.map((item, index) => {
                        return <VatReturnAmountComponent
                            box={item.box}
                            key={index}
                            details={item.details}
                            updateData={(box, value) => { updateData(box, value) }}
                            amount={item.amount}
                        />
                    })}
                    <div className="row mt-1">
                        <p className="fs-md me-3">EC Supplies and Purchases Excluding VAT</p>
                    </div>
                    {suppliesExcludingVat?.map((item, index) => {
                        return <VatReturnAmountComponent
                            box={item.box}
                            key={index}
                            details={item.details}
                            updateData={(box, value) => { updateData(box, value) }}
                            amount={item.amount}
                        />
                    })}
                </div>

            </div>
            {
                props.hmrcMtd && (
                    <div className={`${styles["vat-footer"]}`}>
                        <BarComponent />
                        <div className="d-flex justify-content-end align-items-center ps-3 pe-3 pt-2 pb-2">
                            <Button className="common-btn me-1">Submit to HMRC</Button>
                        </div>
                    </div>
                )
            }
        </Fragment>

    )
};

export default VatReturnTab;